const intro = (
  <p>
    <strong>Mapa wynagrodzeń</strong> to narzędzie, które pozwala lekarzom i
    lekarzom dentystom sprawdzić i porównać poziomy zarobków w różnych regionach
    Polski. Dane prezentowane w bazie są tworzone na podstawie opinii
    zweryfikowanych użytkowników, co zapewnia ich rzetelność i zgodność z
    realiami rynkowymi. Użytkownicy mogą analizować wynagrodzenia według
    specjalizacji, poziomu doświadczenia, województwa oraz typu placówki
    medycznej. To narzędzie wspiera świadome zarządzanie karierą i pozwala na
    lepsze przygotowanie do negocjacji wynagrodzenia.
  </p>
);

export const salaryReportDescription = {
  intro,
  content: (
    <>
      <p>
        Wynagrodzenia lekarzy i lekarzy dentystów różnią się w zależności od
        doświadczenia, regionu, a także rodzaju zatrudnienia. Mapa wynagrodzeń
        umożliwia dostęp do rzeczywistych danych, które pochodzą bezpośrednio od
        osób pracujących w sektorze medycznym. Dzięki temu użytkownicy mogą
        podejmować lepiej poinformowane decyzje zawodowe i skuteczniej planować
        swoją przyszłość.
      </p>
      <h3>Dlaczego warto skorzystać?</h3>
      <ul>
        <li>
          <p>
            dane na podstawie opinii zweryfikowanych użytkowników – baza
            wynagrodzeń jest tworzona przez osoby aktywnie pracujące w zawodzie,
            co zapewnia jej rzetelność;
          </p>
        </li>
        <li>
          <p>
            precyzyjne filtrowanie – możliwość wyszukiwania informacji według
            specjalizacji, województwa, poziomu doświadczenia oraz typu
            placówki;
          </p>
        </li>
      </ul>
      <p>
        aktualność i transparentność – regularnie aktualizujemy bazę danych, aby
        odzwierciedlała bieżące realia rynkowe.
      </p>
      <h3>Jak działa Mapa wynagrodzeń?</h3>
      <ol>
        <li>
          <p>
            Wybierz kryteria – określ swoją specjalizację, województwo i poziom
            doświadczenia.
          </p>
        </li>
        <li>
          <p>
            Przeglądaj wyniki – zobacz średnie wynagrodzenia dla wybranych
            parametrów.
          </p>
        </li>
      </ol>
      <p>
        Analizuj i planuj – porównaj zarobki w różnych województwach i
        wykorzystaj dane podczas negocjacji wynagrodzenia lub wyboru miejsca
        pracy.
      </p>
      <h3>Wiarygodność danych</h3>
      <p>
        Mapa wynagrodzeń bazuje na opiniach zweryfikowanych użytkowników, co
        sprawia, że informacje są zgodne z realnymi warunkami na rynku pracy.
        Każde zgłoszenie jest analizowane pod kątem rzetelności, co gwarantuje
        wysoką jakość prezentowanych danych.
      </p>
      <p>
        Regularne korzystanie z Mapy wynagrodzeń umożliwia śledzenie trendów
        wynagrodzeń i dostosowanie oczekiwań finansowych do bieżącej sytuacji na
        rynku pracy.
      </p>
    </>
  ),
};
